export const osnArrowPlayerLeftIcon = {
  // eslint-disable-next-line max-len
  data: `<svg width="48" height="48"  viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.5484 11.5L9.75425 17.8131C8.74858 18.9089 8.74858 20.6854 9.75425 21.7811C9.78987 21.8199 9.82661 21.8576 9.86429 21.8942L15.5484 27.3993M9.93548 19.7302H29.1129C34.0211 19.7302 38 23.7081 38 28.6151C38 33.5221 34.0211 37.5 29.1129 37.5H19.2369" stroke="currentColor" stroke-width="3" stroke-linecap="round"/></svg>`,
  name: 'arrow-player-left',
};
